import React,{useState} from 'react'
import useApplication from '../hooks/useApplication'
import CustomApplicationTable from '../features/application/components/customApplicationTable';
import CustomApplicationModal from '../features/application/components/customAppplicationModal';
import { Application } from '../common.interface';

function ApplicationPage() {
  const {loading,fetchApplications,updateApplication,applicationsData}=useApplication();

  const [modalData,setModalData] = useState<Application | null>(null);

    const [showModal,setShowModal] = useState<boolean>(false);

    const displayModal = (id?:string) => {
      if(id){
        const newData = applicationsData.filter((application)=>application._id===id)[0];
        setModalData(newData);
        setShowModal((prev)=>!prev);
    }
      else{
        setShowModal((prev)=>!prev);
      }
      
    }
  
    const handleOpen = () => {
      setShowModal((prev)=>!prev);
    }

  return (
    <div className='w-full pt-2 pr-2'>
      <p className='font-semibold'> FUNDS APPLICATION MANAGEMENT</p>
      <CustomApplicationTable data={applicationsData} myFunction={displayModal} loading={loading} actionText={'Review'}/>
      {modalData&&<CustomApplicationModal open={showModal} handleOpen={handleOpen} data={modalData!} setData={setModalData} />}
      </div>
  )
}

export default ApplicationPage